import { render } from "./AuditTestPage.vue?vue&type=template&id=f69a04aa"
import script from "./AuditTestPage.vue?vue&type=script&lang=js"
export * from "./AuditTestPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__